import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./accordion.html";
class Accordion extends LightningElement {
  constructor(...args) {
    super(...args);
    this.isOpen = false;
    this.rows = [];
    this.isCard = false;
  }
  renderedCallback() {
    this.template.host.classList.add('slds-grid', 'slds-grid_vertical', 'list');
    if (this.isCard) {
      this.template.host.classList.add('slds-card');
    }
    const slot = this.template.querySelector('slot');
    const assignedNodes = slot === null || slot === void 0 ? void 0 : slot.assignedNodes({
      flatten: true
    });
    let isFirst = true;
    /**
     * Styling slotted content doesn't work on lwc so we manually add the styles directly to the slotted elements
     * Issue: https://github.com/salesforce/lwc/issues/58
     */
    assignedNodes === null || assignedNodes === void 0 ? void 0 : assignedNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node;
        if (element.tagName.toLowerCase() === 'appx-accordion-row') {
          // Add top border to all rows but the first
          if (!isFirst) {
            var _element$shadowRoot;
            const summaryElement = (_element$shadowRoot = element.shadowRoot) === null || _element$shadowRoot === void 0 ? void 0 : _element$shadowRoot.querySelector('.list-items');
            if (summaryElement && this.isCard) {
              summaryElement.style.borderTop = '1px solid #e5e5e5';
            }
            this.rows.push(element);
          } else {
            isFirst = false;
          }
        }
      }
    });
  }
  toggle() {
    this.isOpen = !this.isOpen;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Accordion, {
  publicProps: {
    isCard: {
      config: 0
    }
  },
  fields: ["isOpen", "rows"]
});
const __lwc_component_class_internal = _registerComponent(Accordion, {
  tmpl: _tmpl,
  sel: "appx-accordion",
  apiVersion: 62
});
export default __lwc_component_class_internal;